/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { UnitDependencies } from './dependenciesUnitClass.generated';
import { NodeDependencies } from './dependenciesNode.generated';
import { createSymbolNode } from '../../factoriesAny.js';
export var SymbolNodeDependencies = {
  UnitDependencies: UnitDependencies,
  NodeDependencies: NodeDependencies,
  createSymbolNode: createSymbolNode
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesSymbolNode.generated.js
// module id = 135
// module chunks = 0